import { Field, useForm } from "react-final-form";
import MeritoSelect from "../../../../../components/common/MeritoSelect/MeritoSelect";
import type { OtpMode } from "../../../api/connectionHub.types";
import { OTP_MODE_LABELS } from "../../../constants/otpModes.constants";
import styles from "./OtpModeSelect.module.scss";

export interface OtpModeSelectProps { name: string; modes: OtpMode[]; ownerFieldName: string; disabled?: boolean; }

export const OtpModeSelect = ({ name, modes, ownerFieldName, disabled = false }: OtpModeSelectProps): JSX.Element | null => {
  const form = useForm();
  if (modes.length <= 1) return null;
  return <Field<OtpMode | undefined> name={name}>{({ input, meta }) => (
    <div className={`${styles.field} ${meta.touched && meta.error ? styles.invalid : ""} ${disabled ? styles.disabled : ""}`}>
      <MeritoSelect<OtpMode>
        label="OTP Mode"
        value={input.value ?? ""}
        options={modes.map((mode) => ({ value: mode, label: OTP_MODE_LABELS[mode] }))}
        disabled={disabled}
        error={meta.touched && meta.error ? meta.error : undefined}
        onChange={(mode) => {
          input.onChange(mode);
          if (mode !== "email") form.change(ownerFieldName, undefined);
          input.onBlur();
        }}
      />
    </div>
  )}</Field>;
};

export default OtpModeSelect;
